const $ = window.$
import moment from 'moment'
import DatePicker from 'react-datepicker'
import React, {useMemo} from 'react'
import {connect} from 'react-redux'
import {trackEventSP} from 'js/studios/shared/tracking'
import {SHIPPING_COUNTRY_CHOICES} from './data'
import {CheckMarkIcon} from 'js/studios/shared/svg_icons'
import {UploadAttachments, UploadButton, UploadErrors} from 'js/studios/shared/forms/uploader'
import {CheckMarkCard, HelpModal, Select, ENGAGEMENT_BUDGET_OPTIONS, NON_ENGAGEMENT_BUDGET_OPTIONS} from 'js/studios/shared/flows'
import {classNames, keyActivationHandler} from 'js/studios/shared/utils'

export function nextFrame(e) {
  if (e) {
    e.preventDefault()
  }
  window.cm.store.dispatch({type: "PROJECT_CREATION_NEXT_FRAME"})
}

export function previousFrame(e){
  if (e){
    e.preventDefault()
  }
  window.cm.store.dispatch({
    type: "PROJECT_CREATION_PREVIOUS_FRAME"
  })
}

export function goToPreventionFrame(frame){
  window.cm.store.dispatch({
    type: "PROJECT_CREATION_GO_TO_PREVENTION_FRAME",
    frame: frame
  })
}

export function backToHomepage(e){
  if (e){
    e.preventDefault()
  }
  window.location.href = '/'
}

export function resolveValueWithCards(value, cards){
  if (value && cards.find(card => card.name === value)){
    return value
  }
  return null
}

export function setCookie(key, value){
  return $.ajax({
    url: window.cm.urls['cookies-api'],
    type: "POST",
    data: JSON.stringify({
      key: key,
      value: value
    })
  })
}

export class PreviousLink extends React.Component {
  render(){
    return (
      <a
        className="previous"
        tabIndex="0"
        aria-label="Go back to previous step"
        onClick={previousFrame}
        onKeyDown={keyActivationHandler(previousFrame)}>
          <i className="material-icons">chevron_left</i>
      </a>
    )
  }
}

// props:
//   - checked: boolean
//   - onChange: handler. Receives current checked value as boolean.
//   - other props are passed through to the <input>
export function CheckMark(props) {
  const onClick = (ev) => {
    ev.preventDefault()
    props.onChange && props.onChange(!props.checked)
  }

  const inputProps = Object.assign({}, props, { readOnly: true })
  delete inputProps.onChange

  return <div className={classNames("checkbox-wrapper",  {checked: props.checked})} onClick={onClick}>
    <input {...inputProps} />
    <CheckMarkIcon />
  </div>
}

export function CalendarSelect({value, onChange}) {
  const DATE_FORMAT = "MM/DD/YY"
  const minDate = useMemo(() => moment().add(4, "weeks").toDate(), [])
  const handleChange = date => {
    onChange(date && moment(date).format(DATE_FORMAT))
  }
  const handleBlur = ev => {
    handleChange(moment(ev.target.value, DATE_FORMAT).toDate())
  }

  return <div className="calendar date_picker_wrapper fade-in">
    <DatePicker
      selected={value && moment(value, DATE_FORMAT)}
      inline
      onChange={handleChange}
      onBlur={handleBlur}
      dateFormat={DATE_FORMAT}
      minDate={minDate}
    />
  </div>
}


@connect()
export class NotSure extends React.Component {
  setSkip(){
    let skipped = !this.props.checked
    this.props.dispatch({
      type: "UPDATE_PROJECT_CREATION_FIELD",
      field: this.props.field,
      value: skipped
    })

    if (skipped && this.props.fieldsToWipe){
      this.props.fieldsToWipe.forEach(field => {
        this.props.dispatch({
          type: "UPDATE_PROJECT_CREATION_FIELD",
          field: field,
          value: this.props.resetValue || ""
        })
      })
    }
  }

  render() {
    return <div className={classNames("not-sure", {[this.props.className]: this.props.className})}>
      <CheckMark type="checkbox" id={this.props.field} name={this.props.field}  className="checkbox" onChange={this.setSkip.bind(this)} checked={this.props.checked} autoFocus={this.props.autoFocus}/>
      <label htmlFor={this.props.field}>{this.props.children}</label>
    </div>
  }
}

@connect(state => ({
  recipient: state.projectCreationData.recipient,
  isEngagement: state.projectCreation.flow === 'engagement' || state.projectCreationData.categoryTop === 'engagement',
  isNecklace: state.projectCreationData.categorySecondary === 'necklace',
  budgetMin: state.projectCreationData.budgetMin,
  budgetMax: state.projectCreationData.budgetMax,
  budgetSkip: state.projectCreationData.budgetSkip
}))
export class BudgetFrame extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      helpOpen: false
    }
  }

  updateBudget(field, e){
    let value = $(e.target).val(), newValue
    if (parseInt(value)){
      if (field === "budgetMax" && parseInt(this.props.budgetMin) && parseInt(value) < parseInt(this.props.budgetMin)){
        newValue = this.props.budgetMin
        this.props.dispatch({
          type: "UPDATE_PROJECT_CREATION_FIELD",
          field: "budgetMin",
          value: value
        })
        value = newValue
      } else if (field === "budgetMin" && parseInt(this.props.budgetMax) && parseInt(value) > parseInt(this.props.budgetMax)){
        newValue = this.props.budgetMax
        this.props.dispatch({
          type: "UPDATE_PROJECT_CREATION_FIELD",
          field: "budgetMax",
          value: value
        })
        value = newValue
      }
    }

    this.props.dispatch({
      type: "UPDATE_PROJECT_CREATION_FIELD",
      field: field,
      value: value
    })
  }

  openHelp(e){
    e.preventDefault()
    this.setState({
      helpOpen: true
    })
  }

  closeHelp(e){
    e.preventDefault()
    this.setState({
      helpOpen: false
    })
  }

  preventLowBudget(){
    if (!this.props.budgetSkip && this.props.budgetMax){
      if (this.props.isEngagement && this.props.budgetMax <= 500){
        return true
      } else if (!this.props.isEngagement && this.props.budgetMax <= 200){
        return true
      }
    }
    return false
  }

  onSubmit(e){
    if (this.preventLowBudget()){
      e.preventDefault()
      trackEventSP('action_view_prevention_frame', 'consultation', {
        frame: 'prevention-low-budget',
        reason: 'budget-max:' + this.props.budgetMax
      })
      return goToPreventionFrame('prevention-low-budget')
    } else {
      nextFrame(e)
    }
  }

  render(){
    let budgetOptions = []
    if (this.props.isEngagement){
      budgetOptions = ENGAGEMENT_BUDGET_OPTIONS
    } else {
      budgetOptions = NON_ENGAGEMENT_BUDGET_OPTIONS
    }
    let maxValue = budgetOptions[budgetOptions.length - 1] + "+"

    budgetOptions = budgetOptions.map(option => (
      <option value={option} key={option}>${option}</option>
    ))

    budgetOptions.splice(0, 1, <option key="any" value="any">Any</option>)
    budgetOptions.push(<option key={maxValue} value={maxValue}>${maxValue}</option>)
    return (
      <form className="frame-wrapper budget fade-in" onSubmit={this.onSubmit.bind(this)}>
        <div className="frame-contents-wrapper">
          <div className="frame">
            <h2>
              <PreviousLink />
              Set Your Budget
              <a
                className="help material-icons-outlined"
                tabIndex="0"
                aria-label="Open help about budget"
                onClick={this.openHelp.bind(this)}
                onKeyDown={keyActivationHandler(this.openHelp.bind(this))}>
                  info_outline
              </a>
            </h2>
            <p className="subheader-body added-margin">If you have a specific price point in mind, let us know so we can help guide you towards options that fit your budget.</p>
            <div className="field budgets">
              <Select onChange={this.updateBudget.bind(this, 'budgetMin')} value={this.props.budgetMin} disabled={this.props.budgetSkip} label="Min" insertLabelOption={false}>
                <option value="">Min</option>
                {budgetOptions}
              </Select>
              <div className="max-budget">
                <Select onChange={this.updateBudget.bind(this, 'budgetMax')} value={this.props.budgetMax} disabled={this.props.budgetSkip} label="Max" insertLabelOption={false}>
                  <option value="">Max</option>
                  {budgetOptions}
                </Select>
              </div>
            </div>
            {!this.props.isNecklace && (
              <NotSure className="added-margin-top" field="budgetSkip" checked={this.props.budgetSkip} fieldsToWipe={["budgetMin", "budgetMax"]}>I'm not sure</NotSure>
            )}
          </div>
        </div>
        {(this.props.budgetMin.length > 0 || this.props.budgetMax.length > 0 || this.props.budgetSkip) && (
          <div className="action-bar fade-in">
            <button className="btn btn-primary btn-sm">Next</button>
          </div>
        )}
        <HelpModal name="budget" isOpen={this.state.helpOpen} onClose={this.closeHelp.bind(this)}>
          <p>
            Instead of having pre-made jewelry with price tags on them, our goal is to create amazing jewelry that fits <span className="italics">your</span> budget.
          </p>
          {!this.props.isNecklace && (
            <p>
              If you don't know your price point, or aren't comfortable discussing it yet, that's okay too!
            </p>

          )}
        </HelpModal>
      </form>
    )
  }
}

@connect(state => ({
  isEngagement: state.projectCreation.flow === 'engagement' || state.projectCreationData.categoryTop === 'engagement'
}))
export class LowBudgetPreventionFrame extends React.Component {

  componentDidMount(){
    setCookie('prevention_frame', 'prevention-low-budget')
  }

  render(){
    return (
      <form className="frame-wrapper prevention-frame low-budget fade-in" onSubmit={backToHomepage}>
        <div className="frame-contents-wrapper">
          <div className="frame">
            <div className="img-wrapper">
              <img src="//images.custommade.com/Fyqsyd-lFeUPiJqiYDs6B1i4m6s=/custommade-attachments/ab1a91d44dedcbe_custom_made_icon_diamond.png" />
            </div>
            <h2>We're sorry</h2>
            <p className="subheader-body">While we do our best to make special {this.props.isEngagement ? 'engagement rings' : 'jewelry'} accessible to all budgets, your target budget is a bit below the lowest point we're able to offer.</p>
          </div>
        </div>
        <div className="action-bar fade-in">
          <button className="btn btn-primary btn-sm">Back to homepage</button>
        </div>
      </form>
    )
  }
}

@connect(state => ({
  categoryTop: state.projectCreationData.categoryTop,
  sourceCategory: state.projectCreationData.sourceCategory,
  shippingLocation: state.projectCreationData.shippingLocation,
}))
export class ShippingLocationFrame extends React.Component {
  updateField(field, e) {
    this.props.dispatch({
      type: 'UPDATE_PROJECT_CREATION_FIELD',
      field: field,
      value: $(e.target).val(),
    })
  }

  projectNoun() {
    if (this.props.categoryTop === 'engagement') {
      return 'ring'
    }

    switch (this.props.sourceCategory) {
      case 'signet_ring':
      case 'class_ring':
      case 'mens_wedding_band':
      case 'womens_wedding_band':
      case 'cocktail_ring':
      case 'other_ring':
        return 'ring'
      case 'wedding_band_set':
        return 'rings'
      case 'necklace':
        return 'necklace'
      case 'cufflinks':
        return 'cufflinks'
      case 'earrings':
        return 'earrings'
      default:
        return 'project'
    }
  }

  render(){
    return (
      <form className="frame-wrapper prevention-frame fade-in" onSubmit={nextFrame}>
        <div className="frame-contents-wrapper">
          <div className="frame">
            <h2><PreviousLink />Where will we be shipping your {this.projectNoun()}?</h2>
            <p className="subheader-body added-margin">
              We ship to 50+ countries worldwide. Where in the world will your {this.projectNoun()} be delivered?
            </p>
            <div className="field">
              <Select onChange={this.updateField.bind(this, 'shippingLocation')} value={this.props.shippingLocation} label="Choose a response">
                {SHIPPING_COUNTRY_CHOICES.map(choice => <option key={choice.value} value={choice.value}>{choice.text}</option>)}
              </Select>
            </div>
          </div>
        </div>
        {this.props.shippingLocation && this.props.shippingLocation.length > 0 && (
          <div className="action-bar fade-in">
            <button className="btn btn-primary btn-sm">Next</button>
          </div>
        )}
      </form>
    )
  }
}

@connect(state => ({
  source: state.projectCreationData.source,
}))
export class SourceFrame extends React.Component {

  updateField(field, e){
    this.props.dispatch({
      type: "UPDATE_PROJECT_CREATION_FIELD",
      field: field,
      value: $(e.target).val()
    })
  }

  render(){
    return (
      <form className="frame-wrapper prevention-frame fade-in" onSubmit={nextFrame}>
        <div className="frame-contents-wrapper">
          <div className="frame">
            <h2><PreviousLink />How did you find us?</h2>
            <p className="subheader-body added-margin">Whether you stumbled across us on your own, or heard about us from a friend, letting us know how you found your way to us will help us out!</p>
            <div className="field">
              <Select onChange={this.updateField.bind(this, 'source')} value={this.props.source} label="Choose a response">
                <option value="my_significant_other">My significant other</option>
                <option value="friends_or_family">Friends or family</option>
                <option value="internet_search">Search (Google, Bing, etc.)</option>
                <option value="instagram">Instagram</option>
                <option value="tiktok">TikTok</option>
                <option value="youtube">YouTube</option>
                <option value="facebook">Facebook</option>
                <option value="reddit">Reddit</option>
                <option value="pinterest">Pinterest</option>
                <option value="ai">AI Suggestion (ChatGPT, Gemini, etc.)</option>
                <option value="other">Other (Website, Blog, Podcast, etc.)</option>
              </Select>
            </div>
          </div>
        </div>
        {this.props.source && this.props.source.length > 0 && (
          <div className="action-bar fade-in">
            <button className="btn btn-primary btn-sm">Next</button>
          </div>
        )}
      </form>
    )
  }
}


@connect(state => ({
  details: state.projectCreationData.details,
  uploading: state.uploadsWidget.uploading,
}))
export class ShareYourIdea extends React.Component {

  updateDetails(e){
    this.props.dispatch({
      type: "UPDATE_PROJECT_CREATION_FIELD",
      field: "details",
      value: $(e.target).val()
    })
  }

  render(){
    return (
      <form className="frame-wrapper share-your-idea fade-in" onSubmit={nextFrame}>
        <div className="frame-contents-wrapper">
          <div className="frame share-your-idea">
            <h2><PreviousLink /> Some Details To Share With Us? </h2>
            <p className="subheader-body added-margin">Tell us (or show us) what you'd like to make, and we'll help you bring it to life!</p>
            <textarea aria-label="Share your idea here" className="field" placeholder="Share your idea here..." onChange={this.updateDetails.bind(this)} value={this.props.details}></textarea>
            <UploadErrors uploaderKey="share-your-idea" />
            <UploadButton overrideContent={true} wrapperClassName="share-your-idea-upload-button" uploaderKey="share-your-idea">
              <div className="upload-input-container">
                <span className="file-input">No File Selected</span>
                <button type="button" className="btn btn-primary btn-sm">UPLOAD</button>
              </div>
            </UploadButton>
            <div className="attachments-wrapper">
              <UploadAttachments className="large_attachments attachments clearfix" uploaderKey="share-your-idea" />
            </div>
            {this.props.details && this.props.details.trim().length > 0 && (
              <div className="action-bar no-absolute fade-in">
                <button className="btn btn-primary btn-sm" disabled={this.props.uploading}>{this.props.uploading ? "uploading.." : "next"}</button>
              </div>
            )}
          </div>
        </div>
      </form>
    )
  }
}


@connect((state, props) => ({
  metalColor: resolveValueWithCards(state.projectCreationData.metalColor, props.cards),
  metalColorSkip: state.projectCreationData.metalColorSkip
}))
export class MetalColor extends React.Component {

  isChecked(name){
    return this.props.metalColor === name
  }

  toggleChecked(name, _e){
    if (!this.props.metalColorSkip){
      this.props.dispatch({
        type: "UPDATE_PROJECT_CREATION_FIELD",
        field: 'metalColor',
        value: name
      })
    }
  }

  render(){
    return (
      <form className="frame-wrapper fade-in" onSubmit={nextFrame}>
        <div className="frame-contents-wrapper">
          <div className="frame limit-2-items-per-row">
            <h2><PreviousLink />Metal Color</h2>
            <p className="subheader-body">{this.props.subheader || "Do you know what color you’d like your ring to be?"}</p>
            <div className="cards-wrapper">
              {this.props.cards.map(card => (
                <CheckMarkCard
                  key={card.name}
                  name={card.name}
                  className="card-normal"
                  imgUrl={card.img}
                  label={card.label}
                  checked={this.isChecked(card.name)}
                  disabled={this.props.metalColorSkip}
                  toggleChecked={this.toggleChecked.bind(this, card.name)}
                  />
              ))}
            </div>
            <NotSure field="metalColorSkip" fieldsToWipe={['metalColor']} resetValue={[]} checked={this.props.metalColorSkip}>I'm not sure</NotSure>
            <div className="info-note">
              <p>We work in castable precious metals only: sterling silver, gold, and platinum. Mixed-metal designs are subject to certain design limitations.</p>
            </div>
          </div>
        </div>
        {((this.props.metalColor && this.props.metalColor.length > 0) || this.props.metalColorSkip) && (
          <div className="action-bar fade-in">
            <button className="btn btn-primary btn-sm">Next</button>
          </div>
        )}
      </form>
    )
  }
}


@connect((state, props) => ({
  finish: resolveValueWithCards(state.projectCreationData.finish, props.cards),
  finishSkip: state.projectCreationData.finishSkip
}))
export class Finish extends React.Component {

  isChecked(name){
    return this.props.finish === name
  }

  toggleChecked(name, _e){
    if (!this.props.finishSkip){
      this.props.dispatch({
        type: "UPDATE_PROJECT_CREATION_FIELD",
        field: 'finish',
        value: name
      })
    }
  }

  render(){
    return (
      <form className="frame-wrapper fade-in" onSubmit={nextFrame}>
        <div className="frame-contents-wrapper">
          <div className="frame limit-2-items-per-row">
            <h2><PreviousLink />Finish</h2>
            <p className="subheader-body">What overall look are you interested in?</p>
            <div className="cards-wrapper limit-2-row">
              {this.props.cards.map(card => (
                <CheckMarkCard
                  key={card.name}
                  name={card.name}
                  className="card-normal"
                  imgUrl={card.img}
                  label={card.label}
                  checked={this.isChecked(card.name)}
                  disabled={this.props.finishSkip}
                  toggleChecked={this.toggleChecked.bind(this, card.name)}
                  />
              ))}
            </div>
            <NotSure field="finishSkip" fieldsToWipe={['finish']} resetValue={[]} checked={this.props.finishSkip}>I'm not sure</NotSure>
            <div className="info-note">
              <p>A polished or brushed finish is the most durable; oxidized and enamel jewelry are subject to design limitations and require special care and maintenance.</p>
            </div>
          </div>
        </div>
        {((this.props.finish && this.props.finish.length > 0) || this.props.finishSkip) && (
          <div className="action-bar fade-in">
            <button className="btn btn-primary btn-sm">Next</button>
          </div>
        )}
      </form>
    )
  }
}


@connect((state, props) => ({
  gemstones: resolveValueWithCards(state.projectCreationData.gemstones, props.cards),
  gemstonesSkip: state.projectCreationData.gemstonesSkip
}))
export class Gemstones extends React.Component {

  isChecked(name){
    return this.props.gemstones === name
  }

  toggleChecked(name, _e){
    if (!this.props.finishSkip){
      this.props.dispatch({
        type: "UPDATE_PROJECT_CREATION_FIELD",
        field: 'gemstones',
        value: name
      })
    }
  }

  render(){
    return (
      <form className="frame-wrapper fade-in" onSubmit={nextFrame}>
        <div className="frame-contents-wrapper">
          <div className="frame">
            <h2><PreviousLink />Gemstones</h2>
            <p className="subheader-body">{this.props.subheader || "Are you considering any gemstones for your ring?"}</p>
            <div className="cards-wrapper">
              {this.props.cards.map(card => (
                <CheckMarkCard
                  key={card.name}
                  className={this.props.cards.length === 3 ? "card-small" : "card-normal"}
                  name={card.name}
                  imgUrl={card.img}
                  label={card.label}
                  checked={this.isChecked(card.name)}
                  disabled={this.props.gemstonesSkip}
                  toggleChecked={this.toggleChecked.bind(this, card.name)}
                  />
              ))}
            </div>
            <NotSure field="gemstonesSkip" fieldsToWipe={['gemstones']} resetValue={[]} checked={this.props.gemstonesSkip}>I'm not sure</NotSure>
          </div>
        </div>
        {((this.props.gemstones && this.props.gemstones.length > 0) || this.props.gemstonesSkip) && (
          <div className="action-bar fade-in">
            <button className="btn btn-primary btn-sm">Next</button>
          </div>
        )}
      </form>
    )
  }
}


@connect((state, props) => ({
  nextSteps: resolveValueWithCards(state.projectCreationData.nextSteps, props.cards)
}))
export class NextSteps extends React.Component {

  isChecked(name){
    return this.props.nextSteps === name
  }

  toggleChecked(name, _e){
    if (!this.props.finishSkip){
      this.props.dispatch({
        type: "UPDATE_PROJECT_CREATION_FIELD",
        field: 'nextSteps',
        value: name
      })
    }
  }

  render(){
    let subheader = this.props.subheader || "We have all the information we need to get started! We can start by talking more about the design of your ring, or we can get right to some price estimates - which would you like to do first?"
    return (
      <form className="frame-wrapper fade-in" onSubmit={nextFrame}>
        <div className="frame-contents-wrapper">
          <div className="frame">
            <h2><PreviousLink />Where Shall We Begin</h2>
            <p className="subheader-body">{subheader}</p>
            <div className="cards-wrapper">
              {this.props.cards.map(card => (
                <CheckMarkCard
                  key={card.name}
                  className="card-block card-text-blocks"
                  name={card.name}
                  label={card.label}
                  checked={this.isChecked(card.name)}
                  disabled={this.props.nextStepsSkip}
                  toggleChecked={this.toggleChecked.bind(this, card.name)}
                  >
                  <p>{card.description}</p>
                </CheckMarkCard>
              ))}
            </div>
          </div>
        </div>
        {(this.props.nextSteps && this.props.nextSteps.length > 0) && (
          <div className="action-bar fade-in">
            <button className="btn btn-primary btn-sm">Next</button>
          </div>
        )}
      </form>
    )
  }
}


@connect((state, props) => ({
  ringFaceShape: resolveValueWithCards(state.projectCreationData.ringFaceShape, props.cards),
  ringFaceShapeSkip: state.projectCreationData.ringFaceShapeSkip
}))
export class RingFaceShape extends React.Component {

  isChecked(name){
    return this.props.ringFaceShape === name
  }

  toggleChecked(name, _e){
    if (!this.props.finishSkip){
      this.props.dispatch({
        type: "UPDATE_PROJECT_CREATION_FIELD",
        field: 'ringFaceShape',
        value: name
      })
    }
  }

  render(){
    let subheader = this.props.subheader || "The portrait oval is our most popular choice, but there’s no wrong answer when it comes to face shape! Since our rings are fully custom, you aren't limited to the examples - we can create any shape you like."
    return (
      <form className="frame-wrapper fade-in" onSubmit={nextFrame}>
        <div className="frame-contents-wrapper">
          <div className="frame">
            <h2><PreviousLink />Ring Face Shape</h2>
            <p className="subheader-body">{subheader}</p>
            <div className="cards-wrapper">
              {this.props.cards.map(card => (
                <CheckMarkCard
                  key={card.name}
                  className={"card-small " + (card.smallText ? "card-small-text" : "")}
                  name={card.name}
                  imgUrl={card.img}
                  label={card.label}
                  checked={this.isChecked(card.name)}
                  disabled={this.props.ringFaceShapeSkip}
                  toggleChecked={this.toggleChecked.bind(this, card.name)}
                  />
              ))}
            </div>
            <NotSure field="ringFaceShapeSkip" fieldsToWipe={['ringFaceShape']} resetValue={[]} checked={this.props.ringFaceShapeSkip}>I'm not sure yet</NotSure>
          </div>
        </div>
        {((this.props.ringFaceShape && this.props.ringFaceShape.length > 0) || this.props.ringFaceShapeSkip) && (
          <div className="action-bar fade-in">
            <button className="btn btn-primary btn-sm">Next</button>
          </div>
        )}
      </form>
    )
  }
}


@connect((state, props) => ({
  raisedOrRecessed: resolveValueWithCards(state.projectCreationData.raisedOrRecessed, props.cards),
  raisedOrRecessedSkip: state.projectCreationData.raisedOrRecessedSkip
}))
export class RaisedOrRecessed extends React.Component {

  isChecked(name){
    return this.props.raisedOrRecessed === name
  }

  toggleChecked(name, _e){
    if (!this.props.finishSkip){
      this.props.dispatch({
        type: "UPDATE_PROJECT_CREATION_FIELD",
        field: 'raisedOrRecessed',
        value: name
      })
    }
  }

  render(){
    return (
      <form className="frame-wrapper fade-in" onSubmit={nextFrame}>
        <div className="frame-contents-wrapper">
          <div className="frame">
            <h2><PreviousLink />Raised or Recessed</h2>
            <p className="subheader-body">If you intend to use your ring to create a stamp or wax seal, we can mirror the image so that the resulting stamp will properly show the design and/or text. Otherwise, raised vs recessed is just a stylistic choice!</p>
            <div className="cards-wrapper">
              {this.props.cards.map(card => (
                <CheckMarkCard
                  key={card.name}
                  className="card-block"
                  name={card.name}
                  label={card.label}
                  imgs={card.imgs}
                  checked={this.isChecked(card.name)}
                  disabled={this.props.raisedOrRecessedSkip}
                  toggleChecked={this.toggleChecked.bind(this, card.name)}
                  />
              ))}
            </div>
            <NotSure field="raisedOrRecessedSkip" fieldsToWipe={['raisedOrRecessed']} resetValue={[]} checked={this.props.raisedOrRecessedSkip}>I'm not sure yet</NotSure>
          </div>
        </div>
        {((this.props.raisedOrRecessed && this.props.raisedOrRecessed.length > 0) || this.props.raisedOrRecessedSkip) && (
          <div className="action-bar fade-in">
            <button className="btn btn-primary btn-sm">Next</button>
          </div>
        )}
      </form>
    )
  }
}


@connect(state => ({
  ringFaceSize: state.projectCreationData.ringFaceSize,
}))
export class RingFaceSize extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      gender: "male"
    }
  }

  updateField(field, e){
    this.props.dispatch({
      type: "UPDATE_PROJECT_CREATION_FIELD",
      field: field,
      value: $(e.target).val()
    })
  }

  toggleGender(){
    this.setState({gender: this.state.gender === 'female' ? 'male' : 'female'})
  }

  render(){
    return (
      <form className={"frame-wrapper fade-in ring-face-size" + (this.props.ringFaceSize && this.props.ringFaceSize.length > 0 ? " size-" + this.props.ringFaceSize : " size-15mm") + (this.state.gender ? " hand-" + this.state.gender : " hand-female")} onSubmit={nextFrame}>
        <div className="frame-contents-wrapper">
          <div className="frame">
            <h2><PreviousLink />Ring Face Size</h2>
            <p className="subheader-body">We usually recommend a 15mm ring face for a typical man's ring. If you're planning for this to be a pinky ring or for a woman, a 13mm ring face is a
              great fit.  Bigger options (17mm+) make a statement and look good on
              large fingers.
            </p>
            <div className="ring-size-img-wrapper">
              <img className="hand" src={this.props.cards[this.state.gender]} />
              <img className="face-size" src={this.props.cards["face_size"]} />
            </div>
            <a className="toggle-gender" tabIndex="0" onClick={this.toggleGender.bind(this)}>Switch to {this.state.gender === 'female' ? 'male' : 'female'} hand</a>
            <div className="field">
              <Select onChange={this.updateField.bind(this, 'ringFaceSize')} value={this.props.ringFaceSize || ''} label="Choose face size">
                <option value="11mm">Petite (11mm)</option>
                <option value="13mm">Small (13mm)</option>
                <option value="15mm">Standard (15mm)</option>
                <option value="17mm">Large (17mm)</option>
                <option value="19mm">Extra Large (19mm)</option>
                <option value="21mm">Oversized (21mm)</option>
              </Select>
            </div>
          </div>
        </div>
        {(this.props.ringFaceSize && this.props.ringFaceSize.length > 0) && (
          <div className="action-bar fade-in">
            <button className="btn btn-primary btn-sm">Next</button>
          </div>
        )}
      </form>
    )
  }
}


@connect((state, props) => ({
  shoulderDesigns: resolveValueWithCards(state.projectCreationData.shoulderDesigns, props.cards),
  shoulderDesignsSkip: state.projectCreationData.shoulderDesignsSkip
}))
export class ShoulderDesigns extends React.Component {

  isChecked(name){
    return this.props.shoulderDesigns === name
  }

  toggleChecked(name, _e){
    if (!this.props.finishSkip){
      this.props.dispatch({
        type: "UPDATE_PROJECT_CREATION_FIELD",
        field: 'shoulderDesigns',
        value: name
      })
    }
  }

  render(){
    return (
      <form className="frame-wrapper fade-in" onSubmit={nextFrame}>
        <div className="frame-contents-wrapper">
          <div className="frame">
            <h2><PreviousLink />Shoulder Designs</h2>
            <p className="subheader-body">Would you like us to add “shoulder” (side) designs to your piece? We can use the same design on both sides, a different design on each side, or no shoulder designs at all.</p>
            <div className="cards-wrapper">
              {this.props.cards.map(card => (
                <CheckMarkCard
                  key={card.name}
                  className="card-block"
                  name={card.name}
                  label={card.label}
                  imgs={card.imgs}
                  checked={this.isChecked(card.name)}
                  disabled={this.props.shoulderDesignsSkip}
                  toggleChecked={this.toggleChecked.bind(this, card.name)}
                  />
              ))}
            </div>
            <NotSure field="shoulderDesignsSkip" fieldsToWipe={['shoulderDesigns']} resetValue={[]} checked={this.props.shoulderDesignsSkip}>I'm not sure yet</NotSure>
          </div>
        </div>
        {((this.props.shoulderDesigns && this.props.shoulderDesigns.length > 0) || this.props.shoulderDesignsSkip) && (
          <div className="action-bar fade-in">
            <button className="btn btn-primary btn-sm">Next</button>
          </div>
        )}
      </form>
    )
  }
}
